export default {
  getList: (specifiedKey) => ['audit-log-list-' + specifiedKey],
};
